module.exports = __webpack_public_path__ + "static/media/logo-yes-h-square.75b51d9a.png";